import React from 'react';

interface SwipeableContextInterface {
  // Set of slides being rendered
  slides: React.ReactNode | null;
  // The user can set the total number of slides given content
  total: number;
  // The current index of slide being shown
  slideIndex: number;
  // Allows the user to set an index slide. Example: if you render a thumbnails component
  // you can click in one thumbnail and set the right index
  handleChangeSlideIndex: (index: number) => void;
  // We want to probably customize the way the handle the next and previous slides
  // Example: if the user is watching at the last slide and he swipes to the right
  // you will be able to show the first slide.
  handleNext: () => void;
  handlePrevious: () => void;
}

const SwipeableContext = React.createContext<SwipeableContextInterface>({
  slides: null,
  total: 0,
  slideIndex: 0,
  handleNext: () => undefined,
  handlePrevious: () => undefined,
  handleChangeSlideIndex: () => undefined,
});

export { SwipeableContext };
